export function findIndexByParam(list, param, value) {
  for (let i = 0; i < list.length; i += 1) {
    if (list[i][param] === value) {
      return i
    }
  }

  return -1
}

export function findByParam(list, param, value) {
  const index = findIndexByParam(list, param, value)

  return list[index] || null
}
